import type * as CoreSentry from "@sentry/core";

// Disabling type assertions because we use a globalThis with prisma as well, which has type-assertions disabled

// oxlint-disable-next-line remi/no-type-assertions -- bypass lint check for type assertions
const globalForErrorReporter = globalThis as unknown as {
  errorReporter?: ErrorReporter;
};

interface ErrorReporter {
  captureException: CaptureExceptionFunction;
  metrics?: MetricsFunction;
  withScope: WithScopeFunction;
  setUser: SetUserFunction;
  setContext: SetContextFunction;
}

export type CaptureExceptionFunction = typeof CoreSentry.captureException;
export type WithScopeFunction = typeof CoreSentry.withScope;
type MetricsFunction = typeof CoreSentry.metrics;
type SetUserFunction = typeof CoreSentry.setUser;
type SetContextFunction = typeof CoreSentry.setContext;

export const setErrorReporter = (errorReporter: ErrorReporter) => {
  globalForErrorReporter.errorReporter = errorReporter;
};

export const getErrorReporter = () => {
  return globalForErrorReporter.errorReporter;
};
